<template>
  <div id="paginaEntrate">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Entrate</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <div id="GridParent">
                  <ejs-grid
                    id="gridA"
                    ref="gridA"
                    :dataSource="entrateFullData"
                    :allowSorting="true"
                    :toolbarClick="gridAClickHandler"
                    :toolbar="gridA.toolbarOptions"
                    :height="gridA.height"
                    :allowFiltering="true"
                    :filterSettings="gridA.filterOptions"
                    :editSettings="gridA.editOptions"
                    :actionBegin="gridAactionBegin"
                    :actionComplete="gridAactionComplete"
                  >
                    <e-columns>
                      <e-column
                        field="dataPertinenza"
                        headerText="Data"
                        width="150"
                        :format="settings.formatoData"
                        type="date"
                      ></e-column>
                      <e-column
                        field="soggetto"
                        headerText="Denominazione"
                        width="300"
                        foreignKeyField="id"
                        foreignKeyValue="denominazione"
                        :dataSource="this.soggettiList"
                      ></e-column>
                      <e-column
                        field="tipologia"
                        headerText="Tipologia"
                        width="200"
                      ></e-column>
                      <e-column
                        field="importo"
                        headerText="Importo"
                        width="200"
                      ></e-column>
                      <e-column
                        field="descrizione"
                        headerText="Descrizione"
                        width="200"
                      ></e-column>
                      <e-column
                        field="incassato"
                        headerText="Incassato"
                        width="200"
                      ></e-column>
                      <e-column
                        field="dataScadenzaIncasso"
                        headerText="Data Scadenza"
                        width="200"
                        :format="settings.formatoData"
                        type="date"
                      ></e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA1: dialogDettaglioEntrata ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog
      id="dialogA1"
      ref="dialogA1"
      :header="dialogA1.header"
      :buttons="dialogA1.buttons"
      :visible="dialogA1.visible"
      :showCloseIcon="dialogA1.showCloseIcon"
      :close="dialogA1Close"
      :open="dialogA1Open"
      :zIndex="dialogA1.zIndex"
      :animationSettings="dialogA1.animationSettings"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA1" v-model="dialogA1.tabAdialogA1Index">
        <b-tab title="Entrate">
          <b-row class="match-height">
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Entrata</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipologia" class="h5">Tipologia</label>
                      <ejs-dropdownlist
                        id="tipologia"
                        v-model="entrateActiveData.tipologia"
                        :dataSource="tipologiaList"
                        :fields="tipologiaFields"
                        placeholder="Selezione Tipologia"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="soggetto" class="h5">Soggetto</label>
                      <ejs-dropdownlist
                        id="soggetto"
                        ref="soggetto"
                        v-model="entrateActiveData.soggetto"
                        :dataSource="soggettiList"
                        :fields="soggettiFields"
                        :allowFiltering="true"
                        :filtering="soggettoFiltering"
                        :itemTemplate="itemTemplate"
                        :valueTemplate="valueTemplate"
                        placeholder="soggetto"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="dataPertinenza" class="h5"
                        >Data di Pertinenza</label
                      >
                      <ejs-datepicker
                        id="dataPertinenza"
                        v-model="entrateActiveData.dataPertinenza"
                        :format="settings.formatoData"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="descrizione" class="h5">Descrizione</label>
                      <ejs-textbox
                        id="descrizione"
                        v-model="entrateActiveData.descrizione"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="Descrizione"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="importo" class="h5">Importo</label>
                      <ejs-numerictextbox
                        id="importo"
                        v-model="entrateActiveData.importo"
                        floatLabelType="Never"
                        cssClass=""
                        format="€ ###"
                        placeholder="Importo"
                        showSpinButton="false"
                        showClearButton="true"
                      />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: entrateActiveData.stato  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="stato" class="h5">Stato</label>
                      <ejs-dropdownlist
                        id="stato"
                        v-model="entrateActiveData.stato"
                        :dataSource="entrateStatoList"
                        :fields="labelValFields"
                        placeholder="Selezione Stato"
                      />
                    </b-col>

                  
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="dataScadenzaIncasso" class="h5"
                        >Data Scadenza Incasso</label
                      >
                      <ejs-datepicker
                        id="dataScadenzaIncasso"
                        v-model="entrateActiveData.dataScadenzaIncasso"
                        :format="settings.formatoData"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                      <label for="dataIncassoPrevista" class="h5"
                        >Data Incasso Prevista</label
                      >
                      <ejs-datepicker
                        id="dataIncassoPrevista"
                        v-model="entrateActiveData.dataIncassoPrevista"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>

                    <b-col xl="6" md="6" class="mb-2">
                      <label for="incassato" class="h5">Incassato</label>
                      <ejs-dropdownlist
                        id="incassato"
                        v-model="entrateActiveData.incassato"
                        :dataSource="incassatoList"
                        :fields="incassatoFields"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="dataIncasso" class="h5"
                        >Data Incasso Effettiva</label
                      >
                      <ejs-datepicker
                        id="dataIncasso"
                        v-model="entrateActiveData.dataIncasso"
                        :format="settings.formatoDatepicker"
                        :firstDayOfWeek="settings.firstDayOfWeek"
                      />
                    </b-col>
                   
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="riferimentoContabile" class="h5"
                        >Riferimento Contabile</label
                      >
                      <ejs-textbox
                        id="riferimentoContabile"
                        v-model="entrateActiveData.riferimentoContabile"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="riferimentoContabile"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox
                        id="note"
                        v-model="entrateActiveData.note"
                        floatLabelType="Never"
                        cssClass=""
                        placeholder="note"
                        showClearButton="true"
                        type="text"
                        autocomplete="false"
                      />
                    </b-col>

                    
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  LinkPlugin,
  AlertPlugin,
  ProgressPlugin,
  ToastPlugin,
  SpinnerPlugin,
} from "bootstrap-vue";
// import Vuexy
// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { Query } from "@syncfusion/ej2-data";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
} from "@syncfusion/ej2-vue-inputs";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Aggregate,
  Group,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(LayoutPlugin);
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(DropdownPlugin);
Vue.use(DatePickerPlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ProgressPlugin);
Vue.use(ToastPlugin);
Vue.use(SpinnerPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiSoggettiUrl = "/demo/api/soggetto";
const apiEntrataUrl = "/demo/api/entrata";

var itemVue = Vue.component("itemTemplate", {
  template: `<div><span style="float:left; width:400px;" >{{data.denominazione}}</span><span style="margin-left:2rem;">{{data.partitaIva}}</span></div>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {},
  data() {
    return {
      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: itemVue };
      },

      // generali
      settings: {
        formatoData: "dd-MM-yyyy",
        formatoOra: "HH:mm",
        intervalloOra: 15,
        firstDayOfWeek: 1,
        minDayInteger: 0,
        maxDayInteger: 100,
        stepDayInteger: 1,
      },

      soggettiList: [],
      soggettiFields: { text: "denominazione", value: "id" },
      entrateFullData: [], // elenco completo dati
      entrateActiveId: 0, // Id oggetto attivo (0 se nuovo)
      entrateActiveData: {}, // dati completi dell'oggetto attivo
      tipologiaList: [
        { label: "Ministero", id: "ministero" },
        { label: "Regione", id: "regione" },
        { label: "Comune", id: "comune" },
        { label: "Sponsor", id: "sponsor" },
        { label: "Coproduzione", id: "coproduzione" },
        { label: "Cantelli - Incassi per eventi in programma", id: "cantelli-incassi-eventi-programma" },
        { label: "Cantelli - Altre Entrate", id: "cantelli-altre-entrate" },
        { label: "Cantelli - Quote iscrizioni al premio", id: "cantelli-quote-iscrizioni" },
        { label: "Altro", id: "altro" },
      ],
      tipologiaFields: { text: "label", value: "id" },

      // lista valori stato entrata
      entrateStatoList: [
        { label: "Bozza", val: "bozza" },
        { label: "Confermato", val: "confermato" },
      ],

      // incassato
      incassatoList: [
        { label: "Si", id: "si" },
        { label: "No", id: "no" },
      ],
      incassatoFields: { text: "label", value: "id" },

      // struttura etichetta - valore per dropdown
      labelValFields: { value: "val", text: "label" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA1
      dialogA1: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogA1Ok,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogA1Cancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogA1Index: 0,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo",
            tooltipText: "Inserisci nuovo elemento",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella",
            tooltipText: "Cancella",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          "Search",
        ],
        groupOptions: { showDropArea: false, columns: ["categoria"] },
      }, //
    };
  },
  created() {
    // log
    console.log("Pagina Entrate Creata");
    // inizializzazione elenchi dal backend
    // chiamate API

    // TODO gestione status 401 con redirect a login
    if (localStorage.getItem("userData") !== null) {
      useJwt.get(apiSoggettiUrl).then((d) => {
        // console.log("Elenco soggetti anagrafica");
        // console.log(d.data);
        // filtro in base a isArtista o isTecnico
        this.soggettiList = d.data.filter((obj) => {
          return obj.isFornitore === true;
        });
        // console.log("Elenco Soggetti Filtrati");
        // console.log(this.soggettiList);
      });

      useJwt.get(apiEntrataUrl).then((d) => {
        console.log("Elenco entrate");
        console.log(d.data);
        this.entrateFullData = d.data;
      });
    } else {
      console.log("Non trovo UserData, prova ancora");
    }
  },

  provide: {
    // per grid
    grid: [
      GridToolbar,
      GridSort,
      GridFilter,
      GridEdit,
      ForeignKey,
      Group,
      Aggregate,
    ],
  },
  methods: {
    // per elenco soggetti: filtra la digitazione per cognome
    soggettoFiltering: function (e) {
      var searchData = this.soggettiList;
      var query = new Query();
      // puoi usare contains, startsWith, or endsWith
      query =
        e.text != "" ? query.where("denominazione", "contains", e.text, true) : query;
      e.updateData(searchData, query);
    },
    // per dialogA1
    dialogA1OpenButtonClick() {
      this.$refs.dialogA1.show(true);
    },
    dialogA1Open(args) {
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();

      console.log("Apertura dialogA1");
      // assegnare le informazioni da visualizzare nel dialog A
      console.log("Entrata attiva");
      console.log(this.entrateActiveId);
    },
    dialogA1Close() {
      console.log("Chiusura dialogA1");
      this.dialogA1.tabAdialogA1Index = 0;
    },
    dialogA1Ok() {
      console.log("Cliccato bottone OK di dialogA1");
      // salvataggio informazioni in remoto
      if (this.entrateActiveId === 0) {
        useJwt
          .post(apiEntrataUrl, this.entrateActiveData)
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.makeToast(
                "primary",
                "Successo",
                "Salvataggio avvenuto con successo"
              );
            }
            console.log(res.status);
            console.log(res.data);
            // mi segno ID elemento appena creato
            this.entrateActiveId = res.data.id;
            this.entrateActiveData = res.data;
            return this; // restituisci contesto per permettere aggiornamento gridA
          })
          .then((context) => {
            // gestione risposta
            console.log("Aggiornamento gridA con l'aggiunta di una entrata");
            console.log(this.entrateActiveData);
            context.entrateFullData.push(this.entrateActiveData);
            context.entrateFullData = [...context.entrateFullData];
          });
      } else {
        // salvataggio in caso di edit
        const editUrl = `${apiEntrataUrl}/${this.entrateActiveId}`;
        // qui devo fare caricamento dati ma non include i file da gestire con upload
        useJwt
          .patch(editUrl, this.entrateActiveData)
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.makeToast(
                "primary",
                "Successo",
                "Modifica dell'allestimento"
              );
            }
            console.log(res.status);
            return this; // restituisci contesto per permettere aggiornamento gridA
          })
          .then((context) => {
            console.log("ID elementi salvati");
            const i = this.entrateFullData.findIndex(
              (x) => x.id === this.entrateActiveId
            );
            if (i >= 0) {
              //this.entrateActiveData.id = this.entrateActiveId
              console.log(this.entrateActiveData);
              this.entrateFullData[i] = this.entrateActiveData;
              this.entrateFullData = [...this.entrateFullData];
            }
          });
      }
      this.$refs.dialogA1.hide();
    },
    dialogA1Cancel() {
      console.log("Cliccato bottone Cancel di dialogA1");
      this.$refs.dialogA1.hide();
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        this.dialogA1.header = "Creazione Entrata";
        // ZZZ
        const defaultData = {
          tipologia: null,
          soggetto: null,
          descrizione: null,
          dataPertinenza: null,
          dataScadenzaIncasso: null,
          incassato: null,
          dataIncasso: null,
          dataIncassoPrevista: null,
          riferimentoContabile: null,
          note: null,
          importo: null,
          stato: null,
        };
        this.entrateActiveData = defaultData;
        console.log("Premuto pulsante creazione nuovo allestimento da gridA");
        this.entrateActiveId = 0;
        this.$refs.dialogA1.show(true);
      }
      // pulsante EDIT
      else if (args.item.id === "edit") {
        this.dialogA1.header = "Modifica Entrata";
        console.log("Premuto pulsante modifica da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          let found = false;
          this.entrateActiveId = selectedRow[0].id;
          console.log("gridA, Id selezionato:");
          console.log(this.entrateActiveId);
          for (const i in this.entrateFullData) {
            if (this.entrateFullData[i].id === this.entrateActiveId) {
              console.log("id dell'elenco trovato:");
              console.log("allestimento corrente");
              console.log(this.entrateFullData[i]);
              this.entrateActiveData = this.entrateFullData[i];
              found = true;
              break;
            }
          }
          console.log("Entrata corrente");
          console.log(this.entrateActiveData);
          console.log(this.entrateActiveId);

          if (found) {
            console.log("Edit Entrata");
            this.$refs.dialogA1.show(true);
          } else {
            console.log("Elemento non trovato");
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella");
          console.log(err);
          this.alertAShow();
        }
      }
      // Pulsante DELETE
      else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina allestimento da gridA");
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          const deletedElementId = selectedRow[0].id;

          const deleteUrl = `${apiEntrataUrl}/${deletedElementId}`;
          this.$refs.gridA.ej2Instances.deleteRecord();

          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo");
            // console.log(res.data)
          });
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
        if (e.requestType === "save") {
          const editedData = e.data;
          console.log(editedData);
          // The default edit operation is cancelled
          e.cancel = true;
          const editUrl = `${apiEntrataUrl}/${editedData.id}`;
          useJwt.patch(editUrl, editedData).then((res) => {
            console.log(res);
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridAFlag = true;
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridA.endEdit();
            } else {
              this.makeToast(
                "primary",
                "Attenzione",
                "Salvataggio non riuscito"
              );
            }
          });
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      if (e.requestType === "save") {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false;
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
